import { ExternalTransferTypes } from '@generated/graphql';
import { Alert, Box, Typography } from 'hephaestus/web';
import { Info as InfoIcon } from 'hephaestus/webIcons';
import { useTranslation } from 'react-i18next';

export type DepositExternalTransferTypeAlertsProp = {
  transferType: string;
};

export const DepositExternalTransferTypeAlerts = ({
  transferType,
}: DepositExternalTransferTypeAlertsProp) => {
  const { t } = useTranslation('workflowCompletions');

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      {transferType === ExternalTransferTypes.AllInCash && (
        <Alert variant='outlined' icon={<InfoIcon />} severity='info'>
          <Typography variant='bodySmall' component='p'>
            {t('depositReview.allInCashMessage')}
          </Typography>
        </Alert>
      )}
      {transferType === ExternalTransferTypes.PartialCash && (
        <Alert variant='outlined' icon={<InfoIcon />} severity='info'>
          <Typography variant='bodySmall' component='p'>
            {t('depositReview.partialCashMessage')}
          </Typography>
        </Alert>
      )}
      {transferType === ExternalTransferTypes.AllInKind && (
        <Alert variant='outlined' icon={<InfoIcon />} severity='info'>
          <Typography variant='bodySmall' component='p'>
            {t('depositReview.allInKindMessage')}
          </Typography>
        </Alert>
      )}
    </Box>
  );
};
